import { businessQuotesService } from '@/services/quotes/business';
import type { CopyInsuredObjectResponse } from '@/services/quotes/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteInsuredObject() {
  const queryClient = useQueryClient();

  return useMutation<
    { success: boolean; data?: CopyInsuredObjectResponse; error?: string },
    Error,
    { policyId: string; riskPk: number }
  >({
    mutationKey: ['quotes', 'business', 'delete-insured-object'],
    mutationFn: async ({ policyId, riskPk }) => {
      const response = await businessQuotesService.deleteInsuredObject(
        policyId,
        riskPk
      );
      if (!response.success) throw new Error(response.error || 'Erro');
      return response;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['proposal-details', variables.policyId],
      });
    },
  });
}
